$(".js-load-more").on("click", function () {
  var $this = $(this),
    totalPages = parseInt($("[data-total-pages]").val()),
    currentPage = parseInt($("[data-current-page]").val());
  $this.attr("disabled", true);
  $this.find("[loader]").removeClass("hide");
  $this.find(".load-more-text").addClass("hide");
  currentPage = currentPage + 1;
  var nextUrl = $("[data-next-url]")
    .val()
    .replace(/page=[0-9]+/, "page=" + currentPage);
  $("[data-current-page]").val(currentPage);
  $.ajax({
    url: nextUrl,
    type: "GET",
    dataType: "html",
    success: function (responseHTML) {
      $(".blog-articles").append($(responseHTML).find(".blog-articles").html());

      $this.attr("disabled", false);
      $this.find(".load-more-text").removeClass("hide");
      $this.find("[loader]").addClass("hide");
    },
    complete: function () {
      if (currentPage >= totalPages) {
        $this.remove();
      }
    },
  });
});

const labels = document.querySelectorAll(
  ".color-option > span:not(.visually-hidden)"
);
for (const label of labels) {
  if (!label || !label.dataset.color) continue;
  const hex = colourNameToHex(label.dataset.color || "");
  const contrast = contrastRatio("#FFFFFF", hex);
  label.style.backgroundColor = hex;
  if (contrast < 0.05)
    label.style.border = `1px solid rgb(var(--color-badge-foreground))`;
}

async function onRequestQuoteClick(e) {
  e.stopPropagation();
  e.preventDefault();
  const url = e.target.dataset.url;
  const moq = e.target.dataset.moq;
  const quantity = document.querySelector(
    ".quantity__input[name='quantity']"
  ).value;

  const variant = await _getCurrentVariant();
  const quoteItem = {
    ...variant,
    quantity: parseInt(quantity) || 1,
    url,
    moq,
  };

  addQuoteItem(quoteItem);
}

async function _getCurrentProduct() {
  const product = document.querySelector(`script[id*='ProductJson']`);

  if (product) {
    return JSON.parse(product.innerHTML);
  }

  let url;

  url = `http://${window.location.host + window.location.pathname}.json`;

  return new Promise(async (resolve, reject) => {
    try {
      let response = await fetch(url);
      let { product } = await response.json();
      window.ezfy_product = product;
      resolve(product);
    } catch (error) {
      reject(error);
    }
  });
}

async function _getCurrentVariant() {
  const product = await _getCurrentProduct();
  const variant = await _getVariantID(product);
  const options = [variant.option1, variant.option2, variant.option3].filter(
    (e) => !!e
  );

  return {
    id: variant.id,
    variant_id: variant.id,
    title: `${product.title} - ${variant.title}`,
    sku: variant.sku,
    grams: variant.grams,
    vendor: product.vendor,
    product_id: 8678632096042,
    url: window.location.href,
    image: product.image.src || "",
    handle: product.handle,
    product_title: product.title,
    product_description: product.description || "",
    variant_title: variant.title,
    variant_options: options,
  };
}

function _getVariantID(product) {
  const urlParams = new URLSearchParams(window.location.search);
  const variantID = urlParams.get("variant");

  if (variantID) {
    const variant = product.variants.filter((e) => e.id == variantID)[0];
    return variant || product.variants[0];
  }

  return product.variants[0];
}

function addQuoteItem(quoteItem) {
  const existingQuotes = JSON.parse(localStorage.getItem("quotes")) || [];
  const existing = existingQuotes.find((item) => item.id === quoteItem.id);
  if (existing) {
    existing.quantity += quoteItem.quantity;
  } else {
    existingQuotes.push(quoteItem);
  }
  localStorage.setItem("quotes", JSON.stringify(existingQuotes));
  window.location.href = `${Shopify.routes.root}cart?tab=quote`;
}
